/**
 * SpeechSynthesisDriver - Phat giong doc tieng Viet 100% CUC BO tren trinh duyet
 * CAM KET 100% HOAT DONG TAI BROWSER CLIENT - TUYET DOI KHONG GUI BAT KY REQUEST MANG NAO
 *
 * GIAI QUYET VAN DE GIONG DOC KHONG CO DAU TIENG VIET:
 * - Chrome/Edge getVoices() tra ve mang rong lan dau tien -> phai cho event onvoiceschanged.
 * - Neu chi set utterance.lang = 'vi-VN' ma khong gan voice cu the, trinh duyet thuong dung
 *   giong mac dinh he thong (English) -> doc khong dau, khong ro chu tieng Viet.
 * - Driver nay dung callback-based ensureVoicesReady() (KHONG dung async/await de tranh
 *   bi obfuscator pha vo) dam bao voices da load xong TRUOC KHI phat am.
 */
export class SpeechSynthesisDriver {
  constructor() {
    /** @type {SpeechSynthesis|null} Web Speech API instance */
    this.synth = typeof window !== 'undefined' ? window.speechSynthesis : null;

    /** @type {SpeechSynthesisVoice|null} Giong tieng Viet tot nhat da tim duoc */
    this.vietnameseVoice = null;

    /** @type {number} Toc do doc (0.5 - 2.5) */
    this.speed = 1.0;

    /** @type {number} Am luong (0.0 - 1.0) */
    this.volume = 1.0;

    /** @type {number} Cao do giong (0.1 - 2.0) */
    this.pitch = 1.0;

    /** @type {SpeechSynthesisUtterance|null} Utterance dang phat */
    this.currentUtterance = null;

    /** @type {number|null} Timer watchdog chong Chrome tu ngat */
    this.watchdogTimer = null;

    /** @type {boolean} Danh dau voices da load xong chua */
    this._voicesReady = false;

    /** @type {Function[]} Hang doi callback cho khi voices san sang */
    this._voicesCallbacks = [];

    // Bat dau quy trinh load voices
    this._startVoiceLoading();
  }

  // ---------------------------------------------------------
  // KHOI TAO VOICES (CALLBACK-BASED, KHONG DUNG ASYNC/AWAIT)
  // ---------------------------------------------------------

  /**
   * Bat dau quy trinh load voices.
   * Dung 3 co che song song: getVoices() truc tiep, onvoiceschanged event, polling backup.
   * Timeout toi da 3 giay.
   */
  _startVoiceLoading() {
    if (!this.synth) {
      this._voicesReady = true;
      return;
    }

    // Thu 1: Lay ngay lap tuc (Firefox thuong co san luon)
    var voices = this.synth.getVoices();
    if (voices && voices.length > 0) {
      this._handleVoicesLoaded(voices);
      return;
    }

    // Thu 2: Lang nghe su kien voiceschanged (Chrome/Edge)
    var self = this;
    var resolved = false;

    var onVoicesChanged = function() {
      if (resolved) return;
      var v = self.synth.getVoices();
      if (v && v.length > 0) {
        resolved = true;
        clearInterval(pollTimer);
        clearTimeout(timeoutTimer);
        self._handleVoicesLoaded(v);
      }
    };

    // Dang ky event listener (khong ghi de cac handler khac)
    if (this.synth.onvoiceschanged !== undefined) {
      this.synth.addEventListener('voiceschanged', onVoicesChanged);
    }

    // Thu 3: Polling backup - mot so trinh duyet khong fire event
    var pollTimer = setInterval(function() {
      if (resolved) { clearInterval(pollTimer); return; }
      var v = self.synth.getVoices();
      if (v && v.length > 0) {
        resolved = true;
        clearInterval(pollTimer);
        clearTimeout(timeoutTimer);
        self._handleVoicesLoaded(v);
      }
    }, 150);

    // Thu 4: Timeout toi da 3 giay
    var timeoutTimer = setTimeout(function() {
      clearInterval(pollTimer);
      if (!resolved) {
        resolved = true;
        var lastTry = self.synth.getVoices();
        if (lastTry && lastTry.length > 0) {
          self._handleVoicesLoaded(lastTry);
        } else {
          console.warn('[SpeechDriver] CANH BAO: Khong tim thay bat ky giong doc nao sau 3s!');
          self._voicesReady = true;
          self._flushCallbacks();
        }
      }
    }, 3000);
  }

  /**
   * Xu ly khi da load xong danh sach voices - tim giong Viet tot nhat
   * @param {SpeechSynthesisVoice[]} allVoices
   */
  _handleVoicesLoaded(allVoices) {
    var viVoices = this._filterVietnameseVoices(allVoices);

    console.log('[SpeechDriver] === VOICES DA LOAD XONG ===');
    console.log('[SpeechDriver] Tong voices he thong:', allVoices.length);
    console.log('[SpeechDriver] So giong tieng Viet:', viVoices.length);

    // Log tat ca giong Viet de debug
    for (var i = 0; i < viVoices.length; i++) {
      console.log('[SpeechDriver] Giong Viet #' + (i+1) + ':', viVoices[i].name, '| lang:', viVoices[i].lang, '| local:', viVoices[i].localService);
    }

    if (viVoices.length > 0 && !this.vietnameseVoice) {
      this.vietnameseVoice = this._pickBestVoice(viVoices);
      console.log('[SpeechDriver] DA CHON giong tot nhat:', this.vietnameseVoice.name);
    }

    if (!this.vietnameseVoice && allVoices.length > 0) {
      console.warn('[SpeechDriver] KHONG TIM THAY giong tieng Viet! Dang liet ke tat ca giong co san:');
      for (var j = 0; j < Math.min(allVoices.length, 20); j++) {
        console.log('  Voice:', allVoices[j].name, '| lang:', allVoices[j].lang);
      }
    }

    this._voicesReady = true;
    this._flushCallbacks();
  }

  /**
   * Goi tat ca callback dang cho voices load xong
   */
  _flushCallbacks() {
    var callbacks = this._voicesCallbacks.slice();
    this._voicesCallbacks = [];
    for (var i = 0; i < callbacks.length; i++) {
      try { callbacks[i](); } catch(e) { console.error('[SpeechDriver] Callback error:', e); }
    }
  }

  /**
   * Dam bao voices da san sang roi moi chay callback.
   * Neu da san sang -> goi ngay. Neu chua -> cho hang doi.
   * @param {Function} callback
   */
  _ensureVoicesReady(callback) {
    if (this._voicesReady) {
      callback();
    } else {
      this._voicesCallbacks.push(callback);
    }
  }

  // ---------------------------------------------------------
  // TIM KIEM & LOC GIONG TIENG VIET
  // ---------------------------------------------------------

  /**
   * Loc ra tat ca giong tieng Viet tu danh sach voices
   * @param {SpeechSynthesisVoice[]} [allVoices]
   * @returns {SpeechSynthesisVoice[]}
   */
  _filterVietnameseVoices(allVoices) {
    var voices = allVoices || (this.synth ? this.synth.getVoices() : []) || [];
    return voices.filter(function(v) {
      var lang = (v.lang || '').toLowerCase().replace('_', '-');
      var name = (v.name || '').toLowerCase();
      return (
        lang.startsWith('vi') ||
        name.indexOf('vietnam') !== -1 ||
        name.indexOf('hoaimy') !== -1 ||
        name.indexOf('namminh') !== -1
      );
    });
  }

  /**
   * Public API: Lay danh sach giong tieng Viet (cho ttsControlBar dung)
   * @returns {SpeechSynthesisVoice[]}
   */
  getVietnameseVoices() {
    return this._filterVietnameseVoices();
  }

  /**
   * Chon giong tieng Viet tot nhat theo thu tu uu tien:
   *   1. Natural / Neural / Online (giong AI chat luong cao tren Edge)
   *   2. HoaiMy / NamMinh (giong Microsoft chuan tieng Viet)
   *   3. Google Vietnamese
   *   4. Giong dau tien trong danh sach
   * @param {SpeechSynthesisVoice[]} [voicesList]
   * @returns {SpeechSynthesisVoice|null}
   */
  _pickBestVoice(voicesList) {
    var list = voicesList || this._filterVietnameseVoices();
    if (!list || list.length === 0) return null;

    // Uu tien 1: Natural / Neural / Online
    for (var i = 0; i < list.length; i++) {
      var n = (list[i].name || '').toLowerCase();
      if (n.indexOf('natural') !== -1 || n.indexOf('online') !== -1 || n.indexOf('neural') !== -1) {
        return list[i];
      }
    }

    // Uu tien 2: HoaiMy / NamMinh
    for (var j = 0; j < list.length; j++) {
      var m = (list[j].name || '').toLowerCase();
      if (m.indexOf('hoaimy') !== -1 || m.indexOf('namminh') !== -1) {
        return list[j];
      }
    }

    // Uu tien 3: Google Vietnamese
    for (var k = 0; k < list.length; k++) {
      if ((list[k].name || '').toLowerCase().indexOf('google') !== -1) {
        return list[k];
      }
    }

    // Uu tien 4: Giong dau tien
    return list[0];
  }

  /**
   * Public API: Lay giong tot nhat
   * @param {SpeechSynthesisVoice[]} [voicesList]
   * @returns {SpeechSynthesisVoice|null}
   */
  getBestVoice(voicesList) {
    return this._pickBestVoice(voicesList);
  }

  // ---------------------------------------------------------
  // CHON GIONG THU CONG
  // ---------------------------------------------------------

  /**
   * Chon giong doc theo ten cu the
   * @param {string} name
   */
  setVoiceByName(name) {
    if (!this.synth || !name) return;

    if (name === 'auto' || name === 'default') {
      this.vietnameseVoice = this._pickBestVoice();
      return;
    }

    var voices = this.synth.getVoices() || [];
    for (var i = 0; i < voices.length; i++) {
      if (voices[i].name === name) {
        this.vietnameseVoice = voices[i];
        console.log('[SpeechDriver] Da chuyen sang giong native:', voices[i].name);
        return;
      }
    }
  }

  /**
   * Kiem tra co giong tieng Viet native hay khong
   * @returns {boolean}
   */
  hasVietnameseVoice() {
    if (this.vietnameseVoice) return true;
    return this._filterVietnameseVoices().length > 0;
  }

  // ---------------------------------------------------------
  // PHAT AM THANH - 100% CUC BO, KHONG GOI API MANG
  // ---------------------------------------------------------

  /**
   * Doc mot doan van ban su dung Web Speech API 100% CUC BO.
   * TUYET DOI KHONG GOI API MANG.
   *
   * LOGIC CHINH:
   * 1. Kiem tra synth ho tro
   * 2. CHO voices load xong (qua callback, KHONG dung async/await)
   * 3. Gan voice tieng Viet cu the vao utterance
   * 4. Phat am
   *
   * @param {string} text Noi dung can doc
   * @param {Function} onEnd Callback khi doc xong
   * @param {Function} onError Callback khi gap loi
   * @returns {Promise<void>}
   */
  speak(text, onEnd, onError) {
    var self = this;

    return new Promise(function(resolve) {
      // Guard: Trinh duyet khong ho tro
      if (!self.synth) {
        console.warn('[SpeechDriver] Trinh duyet khong ho tro Web Speech API.');
        if (typeof onEnd === 'function') onEnd();
        return resolve();
      }

      // Dung utterance cu neu co
      self.stop();

      // Validate text
      var cleanText = (text || '').trim();
      if (!cleanText) {
        if (typeof onEnd === 'function') onEnd();
        return resolve();
      }

      // *** BUOC QUAN TRONG: CHO VOICES LOAD XONG TRUOC KHI PHAT ***
      // Dung callback thay vi async/await de tuong thich voi obfuscator
      self._ensureVoicesReady(function() {
        // Thu tim lai voice neu chua co (truong hop voices load muon)
        if (!self.vietnameseVoice) {
          self.vietnameseVoice = self._pickBestVoice();
          if (self.vietnameseVoice) {
            console.log('[SpeechDriver] Tim lai duoc giong Viet:', self.vietnameseVoice.name);
          }
        }

        // Tao utterance
        var utterance = new SpeechSynthesisUtterance(cleanText);

        // LUON set lang = 'vi-VN'
        utterance.lang = 'vi-VN';

        // GAN VOICE TIENG VIET CU THE - BAT BUOC de doc chuan dau
        if (self.vietnameseVoice) {
          utterance.voice = self.vietnameseVoice;
          utterance.lang = self.vietnameseVoice.lang || 'vi-VN';
          console.log('[SpeechDriver] Dang doc voi giong:', self.vietnameseVoice.name, '| lang:', utterance.lang);
        } else {
          console.warn('[SpeechDriver] KHONG CO GIONG VIET! Doc voi lang=vi-VN fallback. Co the doc sai dau!');
        }

        // Thiet lap toc do, am luong, cao do
        utterance.rate = self.speed;
        utterance.volume = self.volume;
        utterance.pitch = self.pitch;

        self.currentUtterance = utterance;

        // Callback khi doc xong
        utterance.onend = function() {
          self.clearWatchdog();
          self.currentUtterance = null;
          if (typeof onEnd === 'function') onEnd();
          resolve();
        };

        // Callback loi - tiep tuc cau tiep, KHONG fallback API
        utterance.onerror = function(e) {
          self.clearWatchdog();
          self.currentUtterance = null;
          if (e.error !== 'canceled' && e.error !== 'interrupted') {
            console.warn('[SpeechDriver] Web Speech API error:', e.error);
          }
          if (typeof onEnd === 'function') onEnd();
          resolve();
        };

        // Khoi dong watchdog chong bug Chrome tu ngat sau 10-15s
        self.startWatchdog();

        try {
          self.synth.speak(utterance);
        } catch (err) {
          console.warn('[SpeechDriver] Synth speak exception:', err);
          self.clearWatchdog();
          if (typeof onEnd === 'function') onEnd();
          resolve();
        }
      });
    });
  }

  // ---------------------------------------------------------
  // DIEU KHIEN: TAM DUNG / TIEP TUC / DUNG
  // ---------------------------------------------------------

  /** Tam dung doc */
  pause() {
    if (this.synth && this.synth.speaking) {
      this.synth.pause();
    }
  }

  /** Tiep tuc doc */
  resume() {
    if (this.synth && this.synth.paused) {
      this.synth.resume();
    }
  }

  /** Dung doc ngay lap tuc */
  stop() {
    this.clearWatchdog();
    if (this.synth) {
      this.synth.cancel();
    }
    this.currentUtterance = null;
  }

  // ---------------------------------------------------------
  // CAP NHAT THAM SO
  // ---------------------------------------------------------

  /** Cap nhat toc do doc (0.5x -> 2.5x) */
  setSpeed(speed) {
    this.speed = Math.max(0.5, Math.min(2.5, speed));
  }

  /** Cap nhat am luong (0.0 -> 1.0) */
  setVolume(volume) {
    this.volume = Math.max(0, Math.min(1, volume));
  }

  // ---------------------------------------------------------
  // WATCHDOG: CHONG BUG CHROME TU NGAT SAU 10-15S
  // ---------------------------------------------------------

  /** Khoi dong watchdog timer */
  startWatchdog() {
    this.clearWatchdog();
    var self = this;
    this.watchdogTimer = setInterval(function() {
      if (self.synth && self.synth.speaking && !self.synth.paused) {
        self.synth.pause();
        self.synth.resume();
      }
    }, 10000);
  }

  /** Xoa watchdog timer */
  clearWatchdog() {
    if (this.watchdogTimer) {
      clearInterval(this.watchdogTimer);
      this.watchdogTimer = null;
    }
  }
}
